export default __webpack_public_path__ + "static/media/peru20211.b07d577f.jpg";